import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "Is this hosted SaaS?",
    answer: "No. We set up Clawbiz on your machine / server / VPS. You own the runtime and data.",
  },
  {
    question: "Do you control my data?",
    answer: "No. Our role is setup and configuration; Clawbiz runs in environments you control.",
  },
  {
    question: "Which messaging apps can you connect?",
    answer: "WhatsApp, Telegram, Discord, Slack, Signal, iMessage and others that Clawbiz supports.",
  },
  {
    question: "Which models do you support?",
    answer: "Claude, GPT, Gemini, OpenRouter targets, and local models via supported backends like Ollama.",
  },
  {
    question: "What if something breaks after a release?",
    answer: "We can be on the hook for upgrades, fixes, and regression cleanups as part of an ongoing ops engagement.",
  },
  {
    question: "Do I need to know how to code?",
    answer: "No. We handle the technical setup. You just need to know what you want your AI to do.",
  },
];

export const FAQSection = () => {
  return (
    <section id="faq" className="py-24 md:py-32 relative overflow-hidden">
      

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-4xl mx-auto space-y-12">
          <motion.div
            className="text-center space-y-4"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="text-4xl md:text-5xl font-display font-medium leading-tight">
              Questions, <span className="gradient-text-cyan">answered</span>.
            </h2>
          </motion.div>

          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((faq, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: index * 0.05 }}
              >
                <AccordionItem
                  value={`item-${index}`}
                  className="glass-card rounded-xl px-6 border-0"
                >
                  <AccordionTrigger className="text-left font-heading text-lg hover:no-underline hover:text-primary transition-colors py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed pt-0 pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              </motion.div>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
